import { render, staticRenderFns } from "./HostingSearch.vue?vue&type=template&id=28131f20&scoped=true&"
import script from "./HostingSearch.vue?vue&type=script&lang=ts&"
export * from "./HostingSearch.vue?vue&type=script&lang=ts&"
import style0 from "./HostingSearch.vue?vue&type=style&index=0&id=28131f20&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28131f20",
  null
  
)

export default component.exports